import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Button,
	notification,
	Statistic,
	Modal,
	InputNumber,
} from "antd";
import { CustomTable } from "../utils/CustomComponents";
import { EditOutlined, RetweetOutlined } from "@ant-design/icons";
const { Text, Title } = Typography;

const QAQCFieldReportAddEticketValuesModal = ({
	eticketModalOpen,
	setEticketModalOpen,
	selectedJob,
	setSelectedJob,
	onCloseModal,
}) => {
	const [loadingTable, setLoadingTable] = useState(false);
	const [loadList, setLoadList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const [refresh, setRefresh] = useState(false);
	// const [hasAllValuesOfEticket, setHasAllValuesOfEticket] = useState(
	// 	selectedJob.hasAllValuesOfEticket || false,
	// );

	const [editingRow, setEditingRow] = useState(null);
	const [draftRow, setDraftRow] = useState({});

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columnsLoads = [
		{
			title: "Delivery Ticket",
			dataIndex: "deliveryTicket",
			key: "deliveryTicket",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Driver",
			dataIndex: "driver",
			key: "driver",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Truck",
			dataIndex: "truck",
			key: "truck",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Load (YD3)",
			dataIndex: "yards",
			key: "yards",
			render: (value) => {
				return (
					<Statistic
						value={value}
						valueStyle={{
							fontSize: 14,
						}}
					/>
				);
			},
		},
		{
			title: "Air Temp. (°F)",
			dataIndex: "ambientTemperature",
			key: "ambientTemperature",
			render: (value, record) => {
				const isEditing = editingRow === record.id;
				const disabled = !isEditing || (value !== null && value !== undefined);

				return (
					<InputNumber
						value={isEditing ? draftRow.ambientTemperature : value}
						onChange={(v) =>
							setDraftRow((prev) => ({ ...prev, ambientTemperature: v }))
						}
						disabled={disabled}
					/>
				);
			},
		},
		{
			title: "Wind (mph)",
			dataIndex: "windSpeed",
			key: "windSpeed",
			render: (value, record) => {
				const isEditing = editingRow === record.id;
				const disabled = !isEditing || (value !== null && value !== undefined);

				return (
					<InputNumber
						value={isEditing ? draftRow.windSpeed : value}
						onChange={(v) => setDraftRow((prev) => ({ ...prev, windSpeed: v }))}
						disabled={disabled}
					/>
				);
			},
		},
		{
			title: "Humidity (%)",
			dataIndex: "humidityPercentage",
			key: "humidityPercentage",
			render: (value, record) => {
				const isEditing = editingRow === record.id;
				const disabled = !isEditing || (value !== null && value !== undefined);

				return (
					<InputNumber
						value={isEditing ? draftRow.humidityPercentage : value}
						onChange={(v) =>
							setDraftRow((prev) => ({ ...prev, humidityPercentage: v }))
						}
						disabled={disabled}
					/>
				);
			},
		},
		{
			title: "Actions",
			key: "actions",
			render: (_, record) => {
				const hasAllValues =
					record.ambientTemperature != null &&
					record.windSpeed != null &&
					record.humidityPercentage != null;

				if (editingRow === record.id) {
					return (
						<Flex gap={8}>
							<Button
								type="primary"
								onClick={() => onSave(record)}
								disabled={hasAllValues}
							>
								Save
							</Button>
							<Button onClick={onCancel}>Cancel</Button>
						</Flex>
					);
				}

				return (
					<Button
						icon={<EditOutlined />}
						type="primary"
						onClick={() => onEdit(record)}
						disabled={editingRow !== null}
					/>
				);
			},
		},
	];

	const onEdit = (record) => {
		setEditingRow(record.id);
		setDraftRow({
			ambientTemperature: record.ambientTemperature ?? undefined,
			windSpeed: record.windSpeed ?? undefined,
			humidityPercentage: record.humidityPercentage ?? undefined,
		});
	};

	const onCancel = () => {
		setEditingRow(null);
		setDraftRow({});
	};

	const onSave = async (record) => {
		if (
			record.ambientTemperature == null &&
			(draftRow.ambientTemperature == null ||
				draftRow.ambientTemperature === "")
		) {
			return openNotification(
				"warning",
				"Missing value",
				"Ambient temperature is required",
			);
		}

		if (
			record.windSpeed == null &&
			(draftRow.windSpeed == null || draftRow.windSpeed === "")
		) {
			return openNotification(
				"warning",
				"Missing value",
				"Wind speed is required",
			);
		}

		if (
			record.humidityPercentage == null &&
			(draftRow.humidityPercentage == null ||
				draftRow.humidityPercentage === "")
		) {
			return openNotification(
				"warning",
				"Missing value",
				"Humidity is required",
			);
		}

		await addEticketValues(
			{
				ambientTemperature: draftRow.ambientTemperature,
				windSpeed: draftRow.windSpeed,
				humidityPercentage: draftRow.humidityPercentage,
			},
			record.id,
		);

		setEditingRow(null);
		setDraftRow({});
	};

	useEffect(() => {
		if (selectedJob) getLoadList();
	}, [refresh, selectedJob]);

	const getLoadList = async () => {
		try {
			setLoadingTable(true);
			const url = api + `/job/get/qc/laboratory/loads/${selectedJob.id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						deliveryTicket: item.deliveryTicket,
						truck: item.truck.number,
						driver: item.driverId.name,
						yards: item.yards,
						ambientTemperature: item.ambientTemperature,
						windSpeed: item.windSpeed,
						humidityPercentage: item.humidityPercentage,
					});
				});
				setLoadList(list);
				const hasAllValuesOfEticket =
					data.payload.length > 0 &&
					data.payload.every(
						(load) =>
							load.humidityPercentage != null &&
							load.ambientTemperature != null &&
							load.windSpeed != null,
					);

				selectedJob.hasAllValuesOfEticket = hasAllValuesOfEticket;
				setLoadingTable(false);
			} else {
				setLoadingTable(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const addEticketValues = async (values, loadId) => {
		try {
			setLoadingTable(true);

			const formData = {
				ambientTemperature: values.ambientTemperature,
				windSpeed: values.windSpeed,
				humidityPercentage: values.humidityPercentage,
			};

			const url = api + `/job/load/add/qc/eticketvalues/${loadId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = {
				Authorization: `Bearer ${token}`,
			};

			const { data } = await axios.post(url, formData);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setRefresh((prev) => !prev);
			} else {
				openNotification("error", "Error", data.message);
				setLoadingTable(false);
			}
		} catch (err) {
			setLoadingTable(false);
			openNotification("error", "Error", "Error while trying to add evidence");
			console.error(err.message);
			return null;
		}
	};

	return (
		<Modal
			title={`Job ID: ${selectedJob?.number}`}
			open={eticketModalOpen}
			onCancel={() => {
				onCloseModal(selectedJob, selectedJob?.hasAllValuesOfEticket);
				setSelectedJob(null);
				setEticketModalOpen(false);
			}}
			footer={null}
			width={1500}
			centered
		>
			<Flex vertical gap={16}>
				<Title level={4}>Ambient Conditions</Title>
				<Button
					type="primary"
					onClick={() => setRefresh((prev) => !prev)}
					icon={<RetweetOutlined />}
					size="large"
					loading={loadingTable}
				/>
				<CustomTable
					columns={columnsLoads}
					data={loadList}
					loading={loadingTable}
				/>
			</Flex>
			{contextHolder}
		</Modal>
	);
};

export default QAQCFieldReportAddEticketValuesModal;
